import { render, staticRenderFns } from "./ManagingTuitionStatistic.vue?vue&type=template&id=47dfc4a3&scoped=true"
import script from "./ManagingTuitionStatistic.vue?vue&type=script&lang=js"
export * from "./ManagingTuitionStatistic.vue?vue&type=script&lang=js"
import style0 from "./ManagingTuitionStatistic.vue?vue&type=style&index=0&id=47dfc4a3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfc4a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47dfc4a3')) {
      api.createRecord('47dfc4a3', component.options)
    } else {
      api.reload('47dfc4a3', component.options)
    }
    module.hot.accept("./ManagingTuitionStatistic.vue?vue&type=template&id=47dfc4a3&scoped=true", function () {
      api.rerender('47dfc4a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingTuitionStatistic.vue"
export default component.exports